import { useWidget } from '../../../../../providers/widget'
import { ExploreWidgetConfig } from '../../../config'

/**
 * Pro search-bar phrases (#935 item 1): one hook over `searchbar.labels` so
 * every consumer renders the same admin-editable string — this replaces the
 * three independent hardcoded copies of the idle-dates wording that used to
 * live in DateFilter and ProFilterBar (the drift trap DateFilter's old
 * DATES_PLACEHOLDER comment warned about).
 *
 * Each leaf is read explicitly (not spread) so the settings→behavior data
 * flow stays statically traceable by the dead-setting sentinel, same as
 * ProWhereField does for the nameFinder leaves.
 */
export function useSbpLabels() {
  const { options } = useWidget<ExploreWidgetConfig>()
  const l = options.searchbar.labels
  return {
    whereLabel: l.whereLabel,
    whenLabel: l.whenLabel,
    whoLabel: l.whoLabel,
    filtersLabel: l.filtersLabel,
    whereIdle: l.whereIdle,
    whenIdle: l.whenIdle,
    whoIdle: l.whoIdle,
    addCheckout: l.addCheckout,
    startPrompt: l.startPrompt,
    clearAll: l.clearAll,
    next: l.next,
    searchDestinations: l.searchDestinations,
    suggestedDestinations: l.suggestedDestinations,
  }
}
